/* eslint-disable no-debugger */
import useMeetTypeMultiSelect from './UseMeetTypeMultiSelect';
import MultiSelect from '../MultiSelect';

const MeetTypeMultiSelect = ({ label, name, value, error, message, onChange, filterIds="" }) => {
  const { options } = useMeetTypeMultiSelect(filterIds);

  return (
    <MultiSelect
      label={label}
      name={name}
      value={value}
      options={options}
      error={error}
      message={message}
      isLoading={false}
      onChange={onChange}
    />
  );
}

export default MeetTypeMultiSelect;